//
// SharedItemManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./SubserviceManager";
import "./Voucher";
import "../models/local/Folder";

var SharedItemManager = createModule("transport::SharedItemManager", ["transport::SubserviceManager"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getSharedByMeFolder: [1],
        getSharedByMe: [1],
        getSharedWithMeFolder: [1],
        getSharedWithMe: [1],
    },
    ,
    ,
]);
export default SharedItemManager;
